export default [
  {
    srno: "20213",
    // title: "Sumit Jaiswal ",
    subtitle: "Sumit Jaiswal ",
    description: "90%",
    imgurl: "	Completed	"
  },
  {
    srno: "20213",
    // title: "Sumit Jaiswal ",
    subtitle: "Sumit Jaiswal ",
    description: " 80%",
    imgurl: "	Completed	"
  },
  {
    srno: "20213",
    // title: "Sumit Jaiswal ",
    subtitle: "Sumit Jaiswal ",
    description: " 85%",
    imgurl: "Ongoing	"
  },
  {
    srno: "20213",
    // title: "Sumit Jaiswal ",
    subtitle: "Sumit Jaiswal ",
    description: "85%",
    imgurl: "Ongoing"
  }
];
